/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Communication13Inputs */

const en_job_form_enum_communication13 = /** @type {(inputs: Job_Form_Enum_Communication13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communication`)
};

const de_job_form_enum_communication13 = /** @type {(inputs: Job_Form_Enum_Communication13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommunikationsfähigkeit`)
};

/**
* | output |
* | --- |
* | "Communication" |
*
* @param {Job_Form_Enum_Communication13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_communication13 = /** @type {((inputs?: Job_Form_Enum_Communication13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Communication13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_communication13(inputs)
	return en_job_form_enum_communication13(inputs)
});
export { job_form_enum_communication13 as "job_form_enum_COMMUNICATION" }